module.exports = "\n<div class=\"root\" v-if=\"canUse\">\n  <!--alert显示-->\n  <alert-dialog\n    v-if=\"showAlert\"\n    @close-dialog=\"showAlert = false\"\n    :action-block=\"actionBlock\"\n    :cancel-block=\"cancelBlock\"\n    :dialog-type=\"dialogType\"\n    :alert-msg=\"alertMsg\"\n  >\n  </alert-dialog>\n  <nlp></nlp>\n  <router-view></router-view>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 2324
// module chunks = 38